type Props = {
    discountCode: string;
    title: string;
    description: string;
};

export function DiscountBanner({ discountCode, title, description }: Props) {
    if (!discountCode) return null;

    return (
        <div
            className="flex items-center gap-3 bg-primary rounded-full px-5 py-3 mx-auto max-w-lg"
            data-testid="discount-banner"
        >
            <span className="text-xl" aria-hidden>
                🎉
            </span>
            <div>
                <p className="text-sm font-semibold text-contrast-text">
                    {title}
                </p>
                <p className="text-xs text-contrast-text opacity-80">
                    {description}
                </p>
            </div>
        </div>
    );
}
